import { PropsWithChildren } from "react";

interface BoxProps extends PropsWithChildren {
    className?: string;
}

export function ContentBox({ children, className }: BoxProps) {
    const additionalStyle = className ?? "";
    return (
        <div
            className={
                "bg-system-white p-32 rounded-2xl mb-40 " + additionalStyle
            }
        >
            {children}
        </div>
    );
}
